import React from 'react';
import clsx from 'clsx';

import Typography from '@material-ui/core/Typography';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const Anexo2 = ({ edicao }) => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-a2" className={classes.title}>
                ANEXO II – Normas para pagamento da taxa de inscrição para professores de escolas privadas
            </Title>

            <Typography className={classes.text} variant="body2">
               O pagamento da taxa de inscrição é aplicado apenas à inscrição de professores de escolas privadas:
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>1</span> 
                Os professores de escolas privadas deverão preencher a ficha de inscrição, disponível no endereço <span className={classes.underline}>professores.olimpiadamirim.obmep.org.br</span>, entre os 
                dias <span className={clsx(classes.bolder, classes.underline)}>4 de maio de 2026 a 29 de maio de 2026</span> e emitir o boleto correspondente à taxa de inscrição, no valor 
                de R$ 45,00 (quarenta e cinco reais), com vencimento único em <span className={clsx(classes.bolder, classes.underline)}>29 de maio de 2026</span>.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>2</span> 
                Os boletos para pagamento da taxa de inscrição só poderão ser emitidos entre <span className={clsx(classes.bolder, classes.underline)}>4 de maio de 2026 e 29 de maio de 2026</span> e quitados 
                até a data do vencimento, <span className={clsx(classes.bolder, classes.underline)}>29 de maio de 2026</span>.
            </Typography>
            
            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>3</span> 
                Não haverá, sob qualquer hipótese, concessão de isenção da taxa de inscrição para os professores de escolas privadas, ainda que sejam instituições filantrópicas.
            </Typography>

            <Typography className={classes.text} component={'div'} variant="body2">
                <span className={classes.item}>4</span> 
                A taxa de inscrição, após o pagamento, não será devolvida sob nenhuma hipótese, salvo em caso de cancelamento da Olimpíada de Professores da OBMEP Mirim por parte do <span className={classes.bolder}>IMPA</span>.
            </Typography>

            <Typography className={classes.text} component={'div'} variant="body2">
                <span className={classes.item}>5</span> 
                O pagamento da taxa de inscrição deverá ser realizado exclusivamente por meio de boleto bancário e poderá ser efetuada em qualquer agência bancária, casa lotérica ou agência dos correios, 
                obedecendo aos critérios estabelecidos nesses correspondentes bancários. Não será aceito pagamento mediante transferência bancária ou outros meios que não o descrito neste Regulamento.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>6</span> 
                O boleto bancário para pagamento da inscrição deverá ser gerado exclusivamente por meio de acesso ao sistema de inscrições da Olimpíada de Professores da OBMEP Mirim, no 
                endereço <span className={classes.underline}>professores.olimpiadamirim.obmep.org.br</span>, que redirecionará o usuário diretamente para o SisPag - Sistema de Pagamentos 
                do <span className={classes.bolder}>IMPA</span> (<span className={clsx(classes.bolder, classes.underline)}>https://sispag.impa.br</span>), no qual o mesmo conseguirá gerar o boleto bancário. Não será confirmada a inscrição cujo pagamento 
                tenha sido efetuado por meio de boleto bancário gerado fora do SisPag.
            </Typography>

            <Typography className={classes.text} component={'div'} variant="body2">
                <span className={classes.item}>7</span> 
                Não haverá prorrogação do prazo de pagamento da taxa de inscrição. Não é permitido o pagamento do boleto após a data de vencimento, não havendo possibilidade de incisão de multa. Não serão 
                confirmadas inscrições cujo boleto tenha sido pago após a data de vencimento.
            </Typography>

            <Typography className={classes.text} component={'div'} variant="body2">
                <span className={classes.item}>8</span> 
                Não é permitido transferir o valor referente ao pagamento da taxa de inscrição de um professor participante para outro.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>9</span> 
                A inscrição do professor de escola privada só será confirmada após o processamento do pagamento pelo sistema bancário e a confirmação do pagamento do boleto dentro do prazo estabelecido.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>10</span>
                O <span className={classes.bolder}>IMPA</span> não se responsabilizará por solicitação de inscrição não recebida por motivos de ordem técnica dos computadores, de falhas de comunicação, de congestionamento das linhas de comunicação, 
                por erro ou atraso dos bancos ou entidades conveniadas no que se refere ao processamento da taxa de inscrição, emissão e pagamento de boletos, bem como outros fatores que impossibilitem a 
                transferência de dados.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>11</span>
                A nota fiscal relativa à taxa de inscrição paga será emitida de acordo com os dados preenchidos para Pagamento da Inscrição/Fatura no momento da emissão do boleto para o pagamento da inscrição no 
                sistema da {edicao}ª Olimpíada de Professores da OBMEP Mirim, exclusivamente em professores.olimpiadamirim.obmep.org.br. Ao prosseguir com o pagamento, tais dados da fatura serão automaticamente 
                enviados ao SisPag - Sistema de Pagamentos do IMPA. Não será possível alterar dados da nota fiscal após a sua emissão.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>12</span> 
                O prazo para emissão de nota fiscal é de até 30 (trinta) dias úteis <span className={classes.bolder}>APÓS</span> a compensação do pagamento do boleto e sua disponibilização será feita na página 
                do SisPag - Sistema de Pagamentos do IMPA, no endereço <span className={clsx(classes.bolder, classes.underline)}>https://sispag.impa.br</span>.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>13</span> 
                A nota fiscal relativa à taxa de inscrição paga será emitida de acordo com os dados preenchidos em Pagamento da Inscrição/Fatura no momento da emissão do boleto para o pagamento da inscrição no sistema 
                da olimpíada e estará disponível para download em até 30 (trinta) dias úteis após a compensação do pagamento do boleto, também na página restrita do professor.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>14</span> 
                Como a nota fiscal somente será emitida em até 30 dias úteis após a confirmação do pagamento da taxa de inscrição, professores que, por ventura, necessitem da nota fiscal para efetuar 
                pagamentos precisarão, obrigatoriamente, caso desejem concluir a inscrição na Olimpíada de Professores da OBMEP Mirim, encontrar alternativas para pagamento da taxa sem a nota fiscal correspondente.
            </Typography>
        </>
    )
}

export default Anexo2;